<template>
    <div class="canvasMenu" v-if="visable" :style="`top:${flowMain.canvasMenuPositionObj.top}px;left:${flowMain.canvasMenuPositionObj.left}px`">
        <ul class="submenu">
            <li @click="attributeHandle" v-if="flowMain.canvasMenuStyle&&flowMain.canvasMenuStyle.length>0">
              <i :class="flowMain.canvasMenuStyle[0].icon"></i>
              <span>{{flowMain.canvasMenuStyle[0].text}}</span>
            </li>
            <li @click="deleteHandle" v-if="flowMain.canvasMenuStyle&&flowMain.canvasMenuStyle.length>1">
              <i :class="flowMain.canvasMenuStyle[1].icon"></i>
              <span>{{flowMain.canvasMenuStyle[1].text}}</span>
            </li>
            <li @click="autoHandle" v-if="flowMain.node_standard_code===1002&&flowMain.editType!=='line'&&flowMain.canvasMenuStyle&&flowMain.canvasMenuStyle.length>2">
              <i :class="flowMain.canvasMenuStyle[2].icon"></i>
              <span>{{flowMain.canvasMenuStyle[2].text}}</span>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
  name: 'canvasMenu',
  inject: ['flowMain'],
  props: {
    visable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 属性编辑方法
    attributeHandle () {
      this.close()
      this.$emit('editHandle', this.flowMain.parameterLine)
    },
    autoHandle () {
      this.close()
      this.$emit('editHandle', this.flowMain.parameterLine, this.flowMain.node_standard_code)
    },
    // 删除方法
    deleteHandle () {
      this.close()
      this.$emit('deleteHandle', this.flowMain.parameterLine)
    },
    close () {
      this.$emit('update:visable', false)
    }
  },
  destroyed () {
    document.removeEventListener('click', this.close, false)
  },
  mounted () {
    document.addEventListener('click', this.close, false)
  }
}
</script>
<style lang="less">
  @import url('../lib/less/canvasMenu.less');
</style>


// WEBPACK FOOTER //
// packages/yz-flow/src/canvasMenu.vue